module.exports = __webpack_public_path__ + "static/media/no-prize-header.7d142aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/no-prize-header.png
// module id = 1851
// module chunks = 6